<template>
  <div class="pro-gate">
    <div :class="{ 'pro-gate__content--locked': !isPro }">
      <slot />
    </div>
    <div v-if="!isPro" class="pro-gate__overlay">
      <v-icon large color="white" class="mb-2">mdi-lock-outline</v-icon>
      <p class="white--text font-weight-bold subtitle-1 mb-1 text-center px-4">Disponível apenas no Plano Pro</p>
      <p class="white--text caption mb-3 text-center px-6">{{ description }}</p>
      <v-btn color="white" small depressed to="/subscribe">
        <v-icon left small color="pink darken-1">mdi-star</v-icon>
        <span style="color:#F50057; font-weight:700;">Contratar Plano Pro</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import store from '../../store'

export default {
  name: 'ProGate',
  props: {
    description: {
      type: String,
      default: 'Faça upgrade para o Plano Pro e desbloqueie análises avançadas.'
    }
  },
  computed: {
    isPro() {
      return (store.state.subscription && store.state.subscription.is_pro)
    }
  }
}
</script>

<style scoped>
.pro-gate {
  position: relative;
}
.pro-gate__content--locked {
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}
.pro-gate__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(100, 0, 40, 0.45);
  border-radius: 12px;
  z-index: 10;
  backdrop-filter: blur(1px);
}
</style>
